import { Routes, Route, useSearchParams } from "react-router-dom";
import ContentRoute from "./routing/ContentRoute";
import ExamRoute from "./routing/ExamRoute";
import IdentityRoute from "./routing/IdentityRoute";
import LeitnerRoute from "./routing/LeitnerRoute";
import ManagementRoute from "./routing/ManagementRoute";
import WorkReportRoute from "./routing/WorkReportRoute";
import BaseRoute from "./routing/BaseRoute";
import DefaultLayout from "../components/layouts/default-layout/DefaultLayout";
import NotFoundDataInDate from "../components/shared/not-found-data-in-date/NotFoundDataInDate";
import CourseNoteSessionsRoute from "./course-note/CourseNoteSessionsRoute";

export default function Routing() {
  const [searchParams] = useSearchParams();

  return (
    <Routes>
      {BaseRoute()}
      {ContentRoute()}
      {ExamRoute()}
      {IdentityRoute()}
      {LeitnerRoute()}
      {ManagementRoute()}
      {WorkReportRoute()}
      <Route
        element={
          <DefaultLayout
            showContactUs={false}
            backUri={`/CourseNoteList?courseId=${searchParams.get("courseId") ?? ""}&categoryId=${searchParams.get("categoryId") ?? ""}`}
            title={"جلسات تدریس"}
          />
        }
      >
        <Route
          path="/CourseNoteSessions"
          element={<CourseNoteSessionsRoute />}
        />
      </Route>
      <Route
        element={<DefaultLayout backUri={"/Dashboard"} title={"خطا 404"} />}
      >
        <Route
          path="*"
          element={
            <NotFoundDataInDate title="بخشی که به دنبال آن هستید وجود ندارد" />
          }
        />
      </Route>
    </Routes>
  );
}
